import React, { useState, useEffect } from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from "../ui/table";
import { Input } from "../ui";
import { Button } from "../ui";
import { Card } from "../ui";
import { Search, Plus } from "lucide-react";
import { foodService } from "../../services/foodService";
import { handleError } from "../../utils/errorHandler";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogFooter,
} from "../ui/AlertDialog";
//import { Spinner } from "../ui/spinner";
import LoadingSpinner from "../common/LoadingSpinner";

import { createToast } from "../ui/toast";

const AdminProducts = ({ setCurrentView, setEditingProduct }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadProducts();
  }, []);

  const handleAddProduct = () => {
    setCurrentView("productos");
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const handleModify = (product) => {
    setEditingProduct(product);
    setCurrentView("productos");
  };

  const handleDeleteClick = (product) => {
    setProductToDelete(product);
    setDeleteDialogOpen(true);
  };

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await foodService.listFoods();
      if (response.success) {
        setProducts(response.data);
      } else {
        setError(response.message);
        const ErrorToast = createToast(response.message, "error");
        return <ErrorToast />;
      }
    } catch (err) {
      handleError(err);
      setError(err.message);
      const ErrorToast = createToast(err.message, "error");
      return <ErrorToast />;
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteConfirm = async () => {
    if (productToDelete) {
      try {
        const response = await foodService.deleteFood(productToDelete.id);
        if (response.success) {
          const SuccessToast = createToast("Producto eliminado exitosamente");
          return <SuccessToast />;
          await loadProducts();
        } else {
          const ErrorToast = createToast(response.message, "error");
          return <ErrorToast />;
        }
      } catch (err) {
        handleError(err);
        const ErrorToast = createToast(err.message, "error");
        return <ErrorToast />;
      }
    }
    setDeleteDialogOpen(false);
    setProductToDelete(null);
  };

  const filteredProducts = products.filter(
    (product) =>
      product.name.toLowerCase().includes(searchTerm) ||
      product.category.toLowerCase().includes(searchTerm)
  );

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 text-center">
        <p className="text-red-500 mb-4">{error}</p>
        <Button onClick={loadProducts}>Reintentar</Button>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6 space-y-6">
      <div className="flex flex-col sm:flex-row justify-between gap-4 items-start sm:items-center">
        <h1 className="text-2xl font-bold">Administrar Productos</h1>
        <Button
          onClick={handleAddProduct}
          className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-lg flex items-center gap-2"
        >
          <Plus className="w-4 h-4" />
          Agregar Producto
        </Button>
      </div>

      <div className="relative">
        <Input
          type="text"
          placeholder="Busca tu producto"
          value={searchTerm}
          onChange={handleSearch}
          className="w-full pl-4 pr-12 py-3 border border-orange-200 rounded-xl"
        />
        <Search className="absolute right-4 top-1/2 transform -translate-y-1/2 text-orange-500 w-5 h-5" />
      </div>

      <Card className="overflow-hidden bg-orange-50 rounded-xl border-orange-200">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="bg-orange-100/50">
                {/* <TableHead className="text-left py-4 px-4">Imagen</TableHead> */}
                <TableHead className="text-left py-4 px-4">Nombre</TableHead>
                <TableHead className="text-left py-4 px-4">Categoría</TableHead>
                <TableHead className="text-left py-4 px-4">Precio</TableHead>
                {/* <TableHead className="py-4 px-4">Estado</TableHead> */}
                <TableHead className="py-4 px-4"></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {filteredProducts.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} className="text-center py-8">
                    No se encontraron productos
                  </TableCell>
                </TableRow>
              ) : (
                filteredProducts.map((product) => (
                  <TableRow
                    key={product.id}
                    className="border-t border-orange-200"
                  >
                    {/* <TableCell className="py-4 px-4">
                      <img
                        src={product.image || "/api/placeholder/160/120"}
                        alt={product.name}
                        className="w-20 h-16 object-cover rounded-lg"
                        onError={(e) => {
                          e.target.src = "/api/placeholder/160/120";
                        }}
                      />
                    </TableCell> */}
                    <TableCell className="py-4 px-4">{product.name}</TableCell>
                    <TableCell className="py-4 px-4">
                      {product.category}
                    </TableCell>
                    <TableCell className="py-4 px-4">
                      €{product.price.toFixed(2)}
                    </TableCell>
                    {/* <TableCell className="py-4 px-4">
                      <span
                        className={`px-2 py-1 rounded-full text-xs ${
                          product.statusFood === "available"
                            ? "bg-green-100 text-green-800"
                            : "bg-red-100 text-red-800"
                        }`}
                      >
                        {product.statusFood === "available"
                          ? "Disponible"
                          : "No disponible"}
                      </span>
                    </TableCell> */}
                    <TableCell className="py-4 px-4">
                      <div className="flex gap-2 justify-end">
                        <Button
                          onClick={() => handleModify(product)}
                          className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg"
                        >
                          Modificar
                        </Button>
                        <Button
                          onClick={() => handleDeleteClick(product)}
                          className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg"
                        >
                          Eliminar
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
      </Card>

      <AlertDialog open={deleteDialogOpen} onOpenChange={setDeleteDialogOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>¿Estás seguro?</AlertDialogTitle>
            <AlertDialogDescription>
              Esta acción no se puede deshacer. Se eliminará permanentemente el
              producto "{productToDelete?.name}" y todos sus datos asociados.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction
              onClick={handleDeleteConfirm}
              className="bg-red-500 hover:bg-red-600"
            >
              Eliminar
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default AdminProducts;
